package dev.lingvo.site.components.studio.editor

import androidx.compose.runtime.Composable
import dev.lingvo.shared.isRtl
import dev.lingvo.site.ds.LSelect
import dev.lingvo.site.ds.LSelectOption
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.tf
import org.jetbrains.compose.web.dom.Text

/** The explicit locale channel keeps shared styling intact while geometry and type are customized. */
@Composable
internal fun LocalizePanel(state: StudioUiState, dispatch: (StudioIntent) -> Unit) {
    StudioDisclosure(t("studio.editor.localize_panel.localize", "Localize")) {
        val exact = state.selection.any { it in state.page.overrides[state.view.locale]?.patches.orEmpty() }
        Text(if (state.localizedSelection) tf("studio.different_language", "Different in {language}", "language" to state.view.locale)
            else t("studio.editor.localize_panel.same_for_every_language", "Same for every language"))
        StudioButton(if (exact) t("studio.editor.localize_panel.reset_language", "Reset this language's changes")
            else t("studio.editor.localize_panel.change_language_layout", "Change language layout"), state.editable) {
            dispatch(StudioIntent.Localize(state.selection, !exact))
        }
        if (state.localizedSelection) Text(t("studio.editor.localize_panel.localized_properties", "Position and typography apply to this language. Other layer styling remains shared."))
        if (isRtl(state.view.locale)) LSelect(state.page.overrides[state.view.locale]?.mirror?.toString() ?: "inherit", listOf(
            LSelectOption("inherit", t("studio.editor.localize_panel.inherit_mirroring", "Inherit mirroring")),
            LSelectOption("true", t("studio.editor.localize_panel.mirror_right_to_left_layouts", "Mirror right-to-left layouts")),
            LSelectOption("false", t("studio.editor.localize_panel.keep_original_positions", "Keep original positions")),
        ), { dispatch(StudioIntent.Mirror(it.toBooleanStrictOrNull())) },
            label = t("studio.editor.localize_panel.right_to_left_mirroring", "Right-to-left mirroring"), enabled = state.editable && state.page.slotIds.size == 1)
    }
}
